import { render, staticRenderFns } from "./ActivePostmanInfoModal.vue?vue&type=template&id=7258b9c6&scoped=true&"
import script from "./ActivePostmanInfoModal.vue?vue&type=script&lang=js&"
export * from "./ActivePostmanInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./ActivePostmanInfoModal.vue?vue&type=style&index=0&id=7258b9c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7258b9c6",
  null
  
)

export default component.exports